import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ProductShelf as ProductShelfComponent } from '@thd-olt-component-react/product-shelf';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function ProductShelf({ id }) {

  return (
    <ErrorBoundary name="productShelf">
      <QueryProvider key={id} cacheKey={id}>
        <ProductShelfComponent
          componentId={id}
          componentClass="ProductShelf"
          homepageProductShelf
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

ProductShelf.propTypes = {
  id: string,
};

ProductShelf.defaultProps = {
  id: undefined,
};